// extracted by mini-css-extract-plugin
export default {"wrapper":"SvgIcons_wrapper__MVxsp"};